module.exports = __webpack_public_path__ + "img/Likedblue.1dc793ff.svg";